// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Container, Grid, Segment } from 'semantic-ui-react'
import InstagramEmbed from 'react-instagram-embed'
import { TwitterTimelineEmbed, } from 'react-twitter-embed'

export default class SocialMedia extends Component {
  render () {
    return (
      <Container textAlign='center' className='mt'>
        <h3 className='mb'>Follow us on social media</h3>
        <Grid verticalAlign='top' stackable centered>
          <Grid.Column width='5'>
            <InstagramEmbed
              url='https://www.instagram.com/p/B88-SAiA6nb/'
              hideCaption
              containerTagName='div'
            />
          </Grid.Column>
          <Grid.Column width='5'>
            <Segment>
              <TwitterTimelineEmbed
                sourceType='profile'
                screenName='murkstom'
                options={{ height: 500 }}
              />
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
    )
  }
}
